// extracted by mini-css-extract-plugin
export default {"orderContainer":"OrderPage_orderContainer__68mjL","orderTitle":"OrderPage_orderTitle__AVClM","orderImg":"OrderPage_orderImg__NQ+jN"};